<template>
    <app-content>
        <form action="#">
            <div class="inner">
                <p class="buttons">
                    <app-button-delete @click="deleteItem" v-if="!newItem"/>
                </p>
                <app-content-title v-if="!newItem && !pending"
                                   :title="item.name"/>
                <app-content-title v-if="newItem" :title="translations.newPackage"/>
            </div>
            <app-tabs
                :colsTabs="columnTabs"
                :shouldLoadFirstTab="newItem"
                :loadTab="params.tab"
                @appTabChanged="onAppTabChanged"
            >
            <div :title="translations.information">
                <app-settings @submit="onFormSubmit" :disabled="pending">
                    <app-settings-content>
                        <app-settings-desc :title="translations.basicInfo">
                            <p>
                                <translate>Založeno</translate>
                                :<br/>
                                <span v-html="formatDateAdvanced(item._created)"/>
                            </p>
                        </app-settings-desc>

                        <app-settings-options>
                            <app-settings-col class="field_left">
                                <app-input
                                    :label="translations.name"
                                    required
                                    :error="errors.items.find(el => el.field === 'name')"
                                    v-model="formItem.name"
                                    name="name"

                                />
                            </app-settings-col>
                            <app-settings-col class="field_right">
                                <app-settings-select
                                    required
                                    :error="errors.items.find(el => el.field === 'type')"
                                    :label="translations.type"
                                >
                                    <app-select
                                        name="type"
                                        :options="enums.vodType"
                                        v-model="formItem.type"
                                    />
                                </app-settings-select>
                            </app-settings-col>
                            <app-settings-col class="field_left">
                                <app-settings-select
                                    required
                                    :error="errors.items.find(el => el.field === 'idProvider')"
                                    :label="translations.provider"
                                >
                                    <app-select
                                        selectId="provider"
                                        :options="providerOptions"
                                        v-model="formItem.idProvider"
                                        @change="selectProvider"
                                        name="idProvider"
                                    />
                                </app-settings-select>
                            </app-settings-col>
                            <app-settings-col class="field_right">
                                <app-input
                                    :label="translations.importId"
                                    :error="errors.items.find(el => el.field === 'importId')"
                                    v-model="formItem.importId"
                                    name="importId"

                                />
                            </app-settings-col>
                            <app-settings-col class="field_left">
                                <app-settings-control class="checkbox">
                                    <app-checkbox
                                        name="operatorEditable"
                                        :title="translations.operatorEditable"
                                        :error="!!errors.first('active')"
                                        v-model="formItem.operatorEditable"
                                        @change="changeOperatorEditable"
                                    />
                                </app-settings-control>
                            </app-settings-col>

                            <app-settings-col class="field_right">
                                <app-input
                                    :disabled="!operatorEditable"
                                    :label="translations.maximalItemCount"
                                    :error="errors.items.find(el => el.field === 'maximalItemCount')"
                                    v-model="formItem.maximalItemCount"
                                    type="number"
                                    name="maximalItemCount"
                                />
                            </app-settings-col>

                            <app-settings-col class="field_left">
                                <app-datepicker
                                    :label="translations.providedFrom"
                                    :error="errors.items.find(el => el.field === 'providedFrom')"
                                    v-model="formItem.providedFrom"
                                    name="providedFrom"
                                />
                            </app-settings-col>

                            <app-settings-col class="field_right">
                                <app-datepicker
                                    :label="translations.providedTo"
                                    :error="errors.items.find(el => el.field === 'providedTo')"
                                    v-model="formItem.providedTo"
                                    name="providedTo"
                                />
                            </app-settings-col>
                        </app-settings-options>
                    </app-settings-content>

                    <app-settings-buttons :navLinkTitle="translations.list" :nav-link-to="{ name: 'vodPackages' }">
                        <app-content-save-button :disabled="pending" @click="disallowBack"/>
                    </app-settings-buttons>
                </app-settings>
            </div>
            <div :title="translations.prices + ' (' + (item && item.prices ? item.prices.length : 0) + ')'"
                 :data-disabled-title="translations.pricesSaveFirst"
                 :data-disabled="!item || !item._id"
            >
                <Prices key="pricesList" :item="formItem" @pricesChanged="pricesChanged" />
            </div>
            </app-tabs>
        </form>
    </app-content>
</template>

<script>
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { getCommonFormSubmit } from 'utils/form'
import {mapActions, mapState} from "vuex";
import Prices from "@/views/Vod/Prices.vue";

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'Package',
  parentRouteName: 'vodPackages',
  storeModuleName: 'packages',
  storeItemName: 'package',
  enums: true,
})

export default {
  name: 'package-item',
    components: {Prices},
  mixins: [formatDateMixin, itemDetailMixin, appTitleMixin()],
  data() {
    return {
      operatorEditable: false,
      providerId: null,
      columnTabs: [0, 1]
    }
  },
  created() {
      this.getProvidersByName();
  },
  methods: {
    ...mapActions([
      'getProviders',
      'updatePackagePrices'
    ]),
    async onFormSubmit(e) {
      this.errors.clear()

      this.formErrors = await this.runValidation()
      if (this.formErrors.items.length > 0) {
        this.appShowErrors(this.formErrors.items.map(v => v.msg))
        return
      }

      const commonFormSubmit = getCommonFormSubmit('Package')
      const response = await commonFormSubmit(this, e).catch(err => err.response)

      this.handleResponseIfError(response)

      if (!this.backAllowed && response.status === 201) {
        this.goToDetail(response.data.data._id)
      }
    },
    async runValidation() {
      await this.errors.clear()
      await this.$validator.validateAll()
      return this.errors
    },
    changeOperatorEditable(value) {
        this.operatorEditable = value;
    },
    getProvidersByName() {
      this.getProviders({
        params: {
          order: 'name'
        }
      })
    },
    selectProvider() {
        this.providerId = this.formItem.idProvider;
    },
    pricesChanged(payload) {
        this.updatePackagePrices(payload);
    },
  },
  computed: {
    ...mapState({
      providerOptions: (state, vm) => {
          return [
              ...state.providers.providers.map(({ _id, name }) => ({
                  value: _id,
                  name,
              }))
          ]
      }
    }),
    translations() {
      return {
        newPackage: this.$gettext('Nový balíček'),
        name: this.$gettext('Název'),
        basicInfo: this.$gettext('Základní údaje'),
        list: this.$gettext('Seznam'),
        information: this.$gettext('Informace'),
        provider: this.$gettext('Poskytovatel'),
        providedFrom: this.$gettext('Poskytováno od'),
        providedTo: this.$gettext('Poskytováno do'),
        type: this.$gettext('Typ balíčku'),
        importId: this.$gettext('Importní ID'),
        maximalItemCount: this.$gettext('Maximální počet položek'),
        operatorEditable: this.$gettext('Editovatelné položky operátorem'),
        prices: this.$gettext('Ceny'),
        pricesSaveFirst: this.$gettext('Ceny'),
      }
    },
    currentTitle() {
      return [
        { name: this.$gettext('Balíčky'), link: { name: 'vodPackages' } },
          this.item.name || this.translations.newPackage
      ]
    },
  },
  watch: {
    formItem() {
        this.operatorEditable = this.formItem.operatorEditable;
    }
  }
}
</script>
